import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl } from '../../../common/rcs_gaz_mc_core_FE';
import { DetailsWrapper, DetailsLink } from './styles';

class MatchDetails extends Component {
  buildTeamName = teamName => teamName.substring(0, 3);
  formatDate = (date) => {
    if (date.indexOf('T')) {
      date = date.split('T');
      [date] = date;
    }
    date = date.split('-').reverse();
    return `${date[0]}/${date[1]}`;
  }

  isHomeWinner = match => (Number(match.homeTeam.score) > Number(match.awayTeam.score)) && match.status === 'Played';
  isAwayWinner = match => (Number(match.homeTeam.score) < Number(match.awayTeam.score)) && match.status === 'Played';

  render() {
    const {
      matches, isOverlay, isOpen, sportId, competitionId, newspaper, linkClassName,
    } = this.props;
    return (
      <React.Fragment>
        {isOpen && matches && matches.length > 0 ?
          <DetailsWrapper isOverlay={isOverlay}>
            {matches.map((match, index) => (
              <DetailsLink
                key={index}
                href={`${prettyMatchUrl(match.homeTeam.teamName, match.awayTeam.teamName, match.matchId, sportId, competitionId, newspaper)}`}
                className={linkClassName}
              >
                <Row
                  style={{
                    display: 'flex',
                    overflow: 'visible',
                    borderBottom: '1px solid white',
                    margin: '0',
                    padding: '8px 0',
                    lineHeight: isOverlay ? '30px' : '15px',
                  }}
                >
                  <Col
                    lg={3}
                    md={3}
                    sm={3}
                    xs={3}
                    style={{ padding: '0 5px' }}
                  >{this.formatDate(match.dateUtc)}
                  </Col>
                  <Col
                    lg={5}
                    md={5}
                    sm={5}
                    xs={5}
                    style={{ padding: '0 5px' }}
                  >
                    <span style={{ fontWeight: this.isHomeWinner(match) ? 'bold' : '' }}>{this.buildTeamName(match.homeTeam.teamName)}</span>
                    <span> - </span>
                    <span style={{ fontWeight: this.isAwayWinner(match) ? 'bold' : '' }}>{this.buildTeamName(match.awayTeam.teamName)}</span>
                  </Col>
                  <Col
                    lg={4}
                    md={4}
                    sm={4}
                    xs={4}
                    style={{ padding: '0 5px', textAlign: 'center' }}
                  >{`${match.homeTeam.score} - ${match.awayTeam.score}`}
                  </Col>
                </Row>
              </DetailsLink>
            ))}
          </DetailsWrapper>
          :
          null}
      </React.Fragment>
    );
  }
}

MatchDetails.propTypes = {
  matches: PropTypes.any,
  isOpen: PropTypes.bool,
  sportId: PropTypes.any,
  competitionId: PropTypes.any,
  newspaper: PropTypes.any,
  isOverlay: PropTypes.bool,
  linkClassName: PropTypes.any,
};

export default MatchDetails;



// WEBPACK FOOTER //
// ./src/components/PlayOffChart/MatchDetails/index.js